import pako from 'pako';

/**
 * Decrypts an AES-256-CBC encrypted + gzipped + base64-encoded payload.
 *
 * @param {string} base64Payload - Base64-encoded (IV + encrypted data)
 * @param {string} passphrase - Same passphrase used in PHP
 * @returns {Promise<Object>} - Decrypted and parsed JSON object
 */
export async function decryptAPIData(base64Payload, passphrase) {
    // console.log('decryptAPIData', base64Payload);
    // Step 1: Decode base64
    const binaryStr = atob(base64Payload);
    const binary = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
        binary[i] = binaryStr.charCodeAt(i);
    }

    // Step 2: Split IV (first 16 bytes) and encrypted content
    const iv = binary.slice(0, 16);
    const encrypted = binary.slice(16);

    // Step 3: Derive AES-256 key using SHA-256 hash of passphrase
    const keyBuffer = await crypto.subtle.digest(
        'SHA-256',
        new TextEncoder().encode(passphrase)
    );

    const cryptoKey = await crypto.subtle.importKey(
        'raw',
        keyBuffer,
        { name: 'AES-CBC' },
        false,
        ['decrypt']
    );

    // Step 4: Decrypt using WebCrypto
    const decryptedBuffer = await crypto.subtle.decrypt(
        { name: 'AES-CBC', iv },
        cryptoKey,
        encrypted
    );

    // Step 5: Gunzip using pako
    const decompressed = pako.ungzip(new Uint8Array(decryptedBuffer), { to: 'string' });

    // Step 6: Parse JSON
    return JSON.parse(decompressed);
}
